var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Admin"}},[_c('AdminBar'),_c('Drawer',{ref:"drawer",attrs:{"channelid":_vm.channelid}}),_c('v-main',[_c('router-view',{on:{"change-channel":_vm.updateDrawer}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }